
import Vue from 'vue';

import { Api } from '../api';
import Global from '../global';
import Base from '../base';

import '../../assets/js/tinymce/tinymce'
import '../../assets/js/tinymce/themes/modern/theme';
import '../../assets/js/tinymce/plugins/link/plugin';
import '../../assets/js/tinymce/plugins/paste/plugin';
import '../../assets/js/tinymce/plugins/lists/plugin';
import '../../assets/js/tinymce/plugins/code/plugin';
import '../../assets/js/tinymce/plugins/preview/plugin';
import '../../assets/js/tinymce/plugins/advlist/plugin';
import '../../assets/js/tinymce/plugins/image/plugin';
import '../../assets/js/tinymce/plugins/media/plugin';
import '../../assets/js/tinymce/plugins/colorpicker/plugin';
import '../../assets/js/tinymce/plugins/textcolor/plugin';

Vue.directive('htmleditor', {
    twoWay: true,
    inserted: (el, binding, vnode) => {

        let _lastfileuploaded;
        let _interval;
        let _hascustomtag;

        if (binding && binding.value) {
            _hascustomtag = binding.value.hascustomtag == true;
        }

        tinymce.PluginManager.add('customtag', (editor) => {

            editor.addButton('customTagButton', {
                text: 'Tag de Resposta',
                icon: false,
                onclick: () => {
                    _pluginWindowsCustomTag(editor)
                }
            });

            editor.addMenuItem('customTagMenuItem', {
                text: 'Tag de Resposta',
                context: 'tools',
                onclick: () => {
                    _pluginWindowsCustomTag(editor)
                }
            });
        });

        function _pluginWindowsCustomTag(editor) {
            editor.windowManager.open({
                title: 'Insira a Resposta',
                body: [
                    { type: 'textbox', name: 'description', label: 'Resposta' }
                ],
                onsubmit: (e) => {
                    editor.insertContent('##' + e.data.description + '##');
                }
            });
        }

        tinymce.init({
            target: el,
            mode: "inline",
            language_url: '/js/tinymce-pt_br.js',
            plugins: ['link', 'colorpicker', 'textcolor', 'paste', 'lists', 'code', 'preview', 'advlist', 'image', 'media', _hascustomtag ? 'customtag' : ''],

            toolbar: "formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | image media" + (_hascustomtag ? " | customTagButton" : ""),

            extended_valid_elements: "customtag",
            custom_elements: "customtag",

            media_live_embeds: true,
            image_advtab: true,
            file_picker_types: 'file image media',
            setup: (editor) => {
                
                _interval = setInterval(() => {
                    if (el.value && el.value.length > 0) {
                        tinymce.get(el.id).getBody().innerHTML = el.value;
                        clearInterval(_interval)
                    }
                }, 1000)

                editor.on('change', () => {
                    clearInterval(_interval)
                    var value = editor.getContent();
                    value = value.replace(/'/g, '\"');
                    value = value.replace(/\r?\n|\r/g, '');

                    el.value = value;

                    setVModelValue(value, vnode)
                });
            },
            file_picker_types: 'image media',

            relative_urls: false,
            remove_script_host: false,
            media_poster: false,
            media_filter_html: false,

            images_upload_url: Global.URL_DOWNLOAD,

            images_upload_handler: (blobInfo, success, failure) => {
                new Api('document/upload', Global.END_POINT_PORTAL_CORPORATIVO)
                    .upload(blobInfo.blob(), "editorhtml", true)
                    .then(result => {
                        success(Global.URL_DOWNLOAD + "editorhtml/" + result.data[0]);
                    }, (err) => {
                        failure('Erro ao fazer upload');
                    });
            },
            audio_template_callback: function (data) {
                return '<audio controls controlsList="nodownload">' + '\n<source src="' + data.source1 + '"' + (data.source1mime ? ' type="' + data.source1mime + '"' : '') + ' />\n' + '</audio>';
            },
            video_template_callback: function (data) {
                if (_lastfileuploaded && _lastfileuploaded.indexOf("audio") > -1)
                    return '<audio controls controlsList="nodownload">' + '\n<source src="' + data.source1 + '"' + (data.source1mime ? ' type="' + data.source1mime + '"' : '') + ' />\n' + '</audio>';
                else
                    return '<video width="' + data.width + '" height="' + data.height + '"' + (data.poster ? ' poster="' + data.poster + '"' : '') + ' controls="controls" controlsList="nodownload">\n' + '<source src="' + data.source1 + '"' + (data.source1mime ? ' type="' + data.source1mime + '"' : '') + ' />\n' + (data.source2 ? '<source src="' + data.source2 + '"' + (data.source2mime ? ' type="' + data.source2mime + '"' : '') + ' />\n' : '') + '</video>';
            },
            file_picker_callback: (cb, value, meta) => {

                if (meta.filetype == 'image') {
                    var input = document.createElement('input');
                    input.setAttribute('type', 'file');
                    input.setAttribute('accept', 'image/*');
                    input.onchange = () => {
                        var file = input.files[0];
                        _lastfileuploaded = file.type;
                        var reader = new FileReader();
                        reader.onload = () => {
                            var id = 'blobid' + (new Date()).getTime();
                            var blobCache = tinymce.activeEditor.editorUpload.blobCache;
                            var base64 = reader.result.split(',')[1];
                            var blobInfo = blobCache.create(id, file, base64);
                            blobCache.add(blobInfo);
                            cb(blobInfo.blobUri(), { title: file.name });
                        };
                        reader.readAsDataURL(file);
                    };
                    input.click();
                }

                if (meta.filetype == 'media') {
                    var input = document.createElement('input');
                    input.setAttribute('type', 'file');
                    input.setAttribute('accept', 'audio/*');
                    input.setAttribute('accept', 'video/*');
                    input.onchange = () => {

                        var file = input.files[0];
                        if (file.size > 1 * 1024 * 1000) {
                            event.target.files = [];
                            return false;
                        }
                        
                        _lastfileuploaded = file.type;
                        var reader = new FileReader();
                        reader.onload = () => {
                            var id = 'blobid' + (new Date()).getTime();
                            var blobCache = tinymce.activeEditor.editorUpload.blobCache;
                            var base64 = reader.result.split(',')[1];
                            var blobInfo = blobCache.create(id, file, base64);
                            blobCache.add(blobInfo);
                            cb(blobInfo.blobUri());
                        };
                        reader.readAsDataURL(file);
                    };
                    input.click();
                }

            }
        });

        function findVModelName(vnode) {
            return vnode.data.directives.find(function (o) {
                return o.name === 'model';
            }).expression;
        }

        function setVModelValue(value, vnode) {
            var prop = findVModelName(vnode)
            eval('vnode.context.' + prop + ' = ' + '\'' + value + '\'')
        }
    }
})